var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{key:_vm.item.path,tag:"component",attrs:{"item":_vm.item,"linked-to":_vm.item.slug || _vm.item.path,"level":_vm.level,"is-parent-active":_vm.isParentActive}})}
var staticRenderFns = []

export { render, staticRenderFns }